import React from 'react';

import {AIS_ROUTES} from 'components/ais/ais.constants';
import {AisAnswerFormationNdPage} from 'pages/ais/answer-formation-nd/ui/ais-answer-formation-nd-page';
import {AisCommentsRequestResultPage} from 'pages/ais/comments-request-result';
import {AisDocumentsByTaxRegister} from 'pages/ais/documents-by-tax-register-page';
import {AisDocumentsInterface} from 'pages/ais/documents-interface-page';
import {AisDocumentsRegister} from 'pages/ais/documents-register-page';
import {AisExplanationInformationPage} from 'pages/ais/explanation-information';
import {FileSharingCard} from 'pages/ais/file-sharing/file-sharing-card';
import {ForecastCommentsPage} from 'pages/ais/forecast-comments-page';
import {MonitorServicesPage} from 'pages/ais/monitor-services-page/monitor-services-page';
import {AisNotificationScenariosSettingsPage} from 'pages/ais/notification-scenarios-settings';
import {OrganizationStructrePageV5} from 'pages/ais/organization-structure-v5';
import {OrganizationStructurePage} from 'pages/ais/organization-structure/organization-structure-page';
import {ReclaimingInformation} from 'pages/ais/reclaiming-information/reclaiming-information';
import {RisksDocumentsMappingPage} from 'pages/ais/risks-documents-mapping';
import {RisksRequestsPage} from 'pages/ais/risks-requests';
import {SubmitIncomeTaxForecast} from 'pages/ais/submit-income-tax-forecast';
import {SummaryTransactionsProtocolInterfacePage} from 'pages/ais/summary-transactions-protocol-interface';
import {IFormAwareTableProps} from 'pages/table-page/query-params-aware-table/query-params-aware-table';

type TAisPageResolverProps = Pick<
    IFormAwareTableProps,
    'entityName' | 'entityType' | 'url' | 'hideTitle' | 'scroll'
> & {entity: string | null; handleFormClose: () => void};

export const AisPageResolver = ({
    entity,
    entityName,
    entityType,
    url,
    handleFormClose,
    scroll,
    hideTitle,
}: TAisPageResolverProps) => {
    switch (entityName) {
        case AIS_ROUTES.FILE_EXCHANGE_ENTITY_NAME:
            return (
                <FileSharingCard
                    url={url}
                    entityType={entityType}
                    entityName={entityName}
                    entity={entity}
                    hideTitle={hideTitle}
                    scroll={scroll}
                />
            );

        case AIS_ROUTES.RECLAIMING_INFORMATION:
            return (
                <ReclaimingInformation
                    url={url}
                    entityType={entityType}
                    entityName={entityName}
                    entity={entity}
                    hideTitle={hideTitle}
                    scroll={scroll}
                />
            );

        case AIS_ROUTES.MONITOR_SERVICES:
            return (
                <MonitorServicesPage
                    url={url}
                    entityType={entityType}
                    entityName={entityName}
                    hasEntity={!!entity}
                    hideTitle={hideTitle}
                    scroll={scroll}
                    handleFormClose={handleFormClose}
                />
            );

        case AIS_ROUTES.EXPLANATION_INFORMATION:
            return (
                <AisExplanationInformationPage
                    url={url}
                    entityType={entityType}
                    entityName={entityName}
                    entity={entity}
                    hideTitle={hideTitle}
                    scroll={scroll}
                />
            );

        case AIS_ROUTES.NOTIFICATION_SCENARIOS_SETTINGS:
            return <AisNotificationScenariosSettingsPage />;

        case AIS_ROUTES.DOCUMENTS_REGISTER:
            return <AisDocumentsRegister />;

        case AIS_ROUTES.DOCUMENTS_INTERFACE:
            return <AisDocumentsInterface />;

        case AIS_ROUTES.DOCUMENTS_BY_TAX_REGISTER:
            return <AisDocumentsByTaxRegister />;

        case AIS_ROUTES.COMMENTS_REQUEST_RESULT:
            return <AisCommentsRequestResultPage />;

        case AIS_ROUTES.ORGANIZATION_STRUCTURE:
            return <OrganizationStructurePage />;

        case AIS_ROUTES.SUMMARY_TRANSACTIONS_PROTOCOL_INTERFACE:
            return <SummaryTransactionsProtocolInterfacePage entityName={entityName} />;

        case AIS_ROUTES.TAX_FORECAST:
            return <SubmitIncomeTaxForecast />;

        case AIS_ROUTES.FORECAST_COMMENTS:
            return <ForecastCommentsPage />;

        case AIS_ROUTES.ORGANIZATION_STRUCTURE_V5:
            return <OrganizationStructrePageV5 />;    

        case AIS_ROUTES.RISKS_DOCUMENTS_MAPPING:
            return <RisksDocumentsMappingPage />;

        case AIS_ROUTES.RISKS_REQUESTS:
            return <RisksRequestsPage />;
        
        case AIS_ROUTES.COMMENTS_REQUEST_RESULT_ND:
            return (
                <AisAnswerFormationNdPage
                    entityName={entityName}
                />
            );

        default:
            return null;
        }
};

type TIsAisPageArgs = Pick<IFormAwareTableProps, 'entityName'>;

export const isAisPage = ({entityName}: TIsAisPageArgs) => Object.values(AIS_ROUTES).includes(entityName);
